// extracted by mini-css-extract-plugin
module.exports = {"splash-screen":"Splash_splash-screen__EHnvk","loading-dot":"Splash_loading-dot__34o1v","run":"Splash_run__V3j20"};